import { MdOutlineDelete } from "react-icons/md";
import { Box } from "@mui/system";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  borderRadius: 5,
};

const DeleteConfirmationModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation("your_testimonial");

  return (
    <Modal
      disableScrollLock={true}
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <center>
          <div className="logout-div">
            <MdOutlineDelete size={50} />
          </div>
          <div className="py-4">
            <span className="font-bold text-[20px] text-[#FA2020]">{t('delete')}</span>
          </div>
          <span className="text-gray-500 font-semibold">
          {t('conformationOfDelete')}
          </span>
          <div className="flex gap-3 justify-center pt-4">
            {/* Cancel Button */}
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {t('cancel')}
            </button>
            {/* Delete Button */}
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
            >
              {t('delete')}
            </button>
          </div>
        </center>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmationModal;
